export default [
  {
    path: '/b/monitoring',
    redirect: '/b/monitoring',
    name: 'bMonitoring',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'bMonitoringIndex',
        component: () => import('@/views/b/monitoring/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'b-monitoring',
          pageTitle: 'Monitoring',
          breadcrumb: [
            {
              text: 'Monitoring',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
